import mergeStyleProps from '@lib/utils/styles/mergeStyleProps';
import React from 'react';

interface LifeIdScrollerProps {
  children?: React.ReactNode;
  totalHeight?: string | number;
  startPoint?: number;
  style?: React.CSSProperties;
  className?: string;
}

const LifeIdScroller: React.FunctionComponent<LifeIdScrollerProps> = ({
  children,
  totalHeight = 0,
  startPoint = 0,
  className,
  style,
}) => {
  return (
    <div
      style={mergeStyleProps(
        {
          width: '100%',
          position: 'relative',
          height: totalHeight,
        },
        style,
      )}
      className={className}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          transform: `translateY(${startPoint}px)`,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default LifeIdScroller;
